import React, { useEffect, useState } from "react";
import "./Loader.css";

const Preloader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setVisible(false);
    };

    // Hide after 7 seconds if window.load doesn't fire
    const timeout = setTimeout(() => setVisible(false), 4000);

    window.addEventListener("load", handleLoad);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  if (!visible) return null;

  return (
    <div id="preloader" className="preloader">
      {/* <button className="th-btn btn-mask th-btn-icon style2 preloaderCls" onClick={() => setVisible(false)}>
        Cancel Preloader
      </button> */}
      <div id="loader" className="th-preloader">
        <div className="preloader-inner">
          <div className="txt-loading">

            {/* Aanandam Valley */}
            {["A", "a","n","a","n", "d","a","m", " ", "V","a", "l","l","e", "y"].map((char, idx) => (
              <span key={idx} data-text-preloader={char} className="letters-loading">
                {char}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
